import { ReferralDeterminantsFormValues, ReferralFormMeta } from 'components/modals/referral/SendReferralModal';
import StandardModal from 'components/shared/StandardModal';
import { Form, FormProvider } from 'context/form';
import useInvalidateQueries from 'hooks/useInvalidateQueries';
import useMutateWithToast from 'hooks/useMutateWithToast';
import { extractDigits } from 'lib/phone';
import Referral from 'models/reviews/Referral';
import { updateReview } from 'services/api/reviews';

import EditDeterminantsStep from './EditDeterminantsStep';
import { referralDeterminantsFormValidation } from './referralFormValidation';

type EditDeterminantsFormProps = {
  initialPhoneNumber: string;
  referral: Referral;
  setShowDeterminantsEdit: (show: boolean) => void;
};

const EditDeterminantsForm = ({ initialPhoneNumber, referral, setShowDeterminantsEdit }: EditDeterminantsFormProps) => {
  const invalidateQueries = useInvalidateQueries();

  const initialValues = {
    phone: initialPhoneNumber,
    expectedDischargeDate: referral.data.expectedDischargeDate ?? null,
    address1: referral.data.address1 ?? '',
    address2: referral.data.address2 ?? '',
    city: referral.data.city ?? '',
    state: referral.data.state ?? '',
    zip: referral.data.zip ?? '',
  };

  const { mutate } = useMutateWithToast({
    mutationFn: updateReview,
    onSuccess: () => {
      invalidateQueries({
        referral: { id: referral.id },
        activities: true,
      });
      setShowDeterminantsEdit(false);
    },
  });

  const handleSubmit = (values: ReferralDeterminantsFormValues) => {
    mutate({
      id: referral.id,
      phoneNumber: extractDigits(values.phone || ''),
      expectedDischargeDate: values.expectedDischargeDate,
      address1: values.address1,
      address2: values.address2,
      city: values.city,
      state: values.state,
      zip: values.zip,
    });
  };

  return (
    <StandardModal title='Edit Referral Information' onCancel={() => setShowDeterminantsEdit(false)}>
      <FormProvider<ReferralDeterminantsFormValues, ReferralFormMeta>
        onSubmit={handleSubmit}
        yupSchema={referralDeterminantsFormValidation()}
        initialValues={initialValues as any}
        initialMeta={{
          submitText: 'Save Changes',
          onCancel: () => setShowDeterminantsEdit(false),
        }}
        resetOnInitialValuesChange>
        <Form>
          <EditDeterminantsStep initialPhoneNumber={initialPhoneNumber} />
        </Form>
      </FormProvider>
    </StandardModal>
  );
};

export default EditDeterminantsForm;
